import { defineMessages } from 'react-intl';

export default defineMessages({
    mlYourInfoHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.YourInfo.header',
        defaultMessage: 'Before we start, tell us about yourself'
    },
    mlQualificationHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.Qualification.header',
        defaultMessage: 'What else should we know about you?'
    },
    mlWatercraftLocationBusinessDetailsHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.WatercraftLocationBusinessDetails.header',
        defaultMessage: 'Properties'
    },
    mlESignatureHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.ESignature.header',
        defaultMessage: 'Sign below to complete your purchase'
    },
    mlPupQuotePageHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.QuotePage.header',
        defaultMessage: 'Your umbrella insurance quote'
    },
    mlDisclosuresHeader: {
        id: 'ml.quoteandbind.pup.wizard.step.Disclosures.header',
        defaultMessage: 'Claims and Violations'
    },
    mlDisclosuresSubtitle: {
        id: 'ml.quoteandbind.pup.wizard.step.Disclosures.subtitle',
        defaultMessage: 'The top section lists your home claims and the bottom section lists your auto accidents and violations.'
    },
    mlVehicleDriverHouseHoldDetailsHEader: {
        id: 'ml.quoteandbind.pup.wizard.step.VehicleDriverHouseHoldDetails.header',
        defaultMessage: 'Vehicles and Drivers'
    }
});
